import React, { createContext, useContext, useState, useEffect } from 'react';
import API from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  // Lee el payload del JWT sin validarlo (solo para arrancar rápido).
  // El backend mete los datos del usuario + `exp` en el token.
  function decodificarJwt(token) {
    try {
      const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(atob(b64));
      if (payload.exp && payload.exp * 1000 < Date.now()) return null;   // vencido
      return payload;
    } catch { return null; }
  }

  useEffect(() => {
    const token = localStorage.getItem('gulliver_token');
    if (!token) { setCargando(false); return; }

    // 1) Sesión optimista: si el token no está vencido, mostramos la app
    //    de inmediato con los datos que trae el token. Así la pantalla no
    //    depende de que el backend responda al instante.
    const local = decodificarJwt(token);
    if (!local) {
      // Token vencido o ilegible: no tiene sentido preguntarle al backend
      // (respondería 401). Limpiamos y vamos directo al login, sin
      // dejar la pantalla en "cargando" mientras tanto.
      localStorage.removeItem('gulliver_token');
      setUsuario(null);
      setCargando(false);
      return;
    }
    setUsuario(local);
    setCargando(false);

    // 2) Validación real contra el backend. Solo cerramos sesión si el
    //    backend dice explícitamente que el token no sirve (401). Antes,
    //    CUALQUIER error (un 502 mientras Render reiniciaba, un timeout)
    //    borraba el token y mandaba al usuario al login — era una de las
    //    causas del "tengo que actualizar 3 veces".
    API.get('/auth/me', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setUsuario(r.data))
      .catch(e => {
        if (e?.response?.status === 401) {
          localStorage.removeItem('gulliver_token');
          setUsuario(null);
        }
      })
      .finally(() => setCargando(false));
  }, []);

  async function loginConGoogle(googleToken) {
    const r = await API.post('/auth/google', { token: googleToken });
    localStorage.setItem('gulliver_token', r.data.token);
    setUsuario(r.data.usuario);
    return r.data.usuario;
  }

  function logout() {
    localStorage.removeItem('gulliver_token');
    setUsuario(null);
  }

  function getToken() {
    return localStorage.getItem('gulliver_token');
  }

  return (
    <AuthContext.Provider value={{ usuario, cargando, loginConGoogle, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
